export const shippingTypeOptions = [
  { value: 1, label: 'ETC' },
  { value: 2, label: 'TAC' },
  { value: 3, label: 'CTC' },
];

export const autonomousOptions = [
  { value: true, label: 'Sim' },
  { value: false, label: 'Não' },
];

export const rntrcOwnOptions = [
  { value: true, label: 'Própria' },
  { value: false, label: 'De terceiros' },
];

export const mockRequests = [
  {
    id: 1,
    userName: 'João da Silva',
    userDocument: '123.456.789-00',
    userEmail: 'joao.silva@email.com',
    userPhone: '(49) 99999-1234',
    shippingName: 'Transportes Rápidos Ltda',
    shippingDocument: '12.345.678/0001-99',
    shippingStateRegistration: '123456789',
    shippingPhone: '(49) 3333-1111',
    shippingEmail: 'contato@transportesrapidos.com.br',
    autonomous: false,
    shippingType: { value: 1, label: 'ETC' },
    address: 'Rua das Flores',
    addressNumber: '123',
    addressNeighborhood: 'Centro',
    addressComplement: 'Sala 2',
    addressZipCode: '89500-000',
    addressCity: 'Caçador',
    addressProvince: 'SC',
    country: 'Brasil',
    anttNumber: 'ET-123456',
    anttIssueDate: '15/06/2022',
    anttType: { value: 1, label: 'ETC' },
    rntrcOwn: true,
    anttTransporterDocument: '',
    certificatePath: 'certificados/2026-03/abc123.pfx',
    certificatePassword: '••••••••',
    timeline: [
      {
        statusSlug: 'DATA_VALIDATION',
        statusName: 'Validação concluída',
        createdAt: '2026-03-20T08:30:00',
        completedAt: '2026-03-20T09:15:00',
      },
      {
        statusSlug: 'EMISSION_PORTAL_REGISTRATION',
        statusName: 'Em cadastro no portal',
        createdAt: '2026-03-20T09:20:00',
        completedAt: null,
      },
    ],
    currentStatus: {
      statusSlug: 'EMISSION_PORTAL_REGISTRATION',
      statusName: 'Aguardando confirmação',
      createdAt: '2026-03-20T09:20:00',
    },
    createdAt: '2026-03-20T08:30:00',
  },
  {
    id: 2,
    userName: 'Maria Oliveira',
    userDocument: '987.654.321-00',
    userEmail: 'maria.oliveira@email.com',
    userPhone: '(48) 98888-5678',
    shippingName: 'Frete Sul Transportes',
    shippingDocument: '98.765.432/0001-11',
    shippingStateRegistration: '987654321',
    shippingPhone: '(48) 3222-4444',
    shippingEmail: 'contato@fretesul.com.br',
    autonomous: false,
    shippingType: { value: 2, label: 'TAC' },
    address: 'Av. Beira Mar',
    addressNumber: '500',
    addressNeighborhood: 'Beira Mar Norte',
    addressComplement: '',
    addressZipCode: '88000-000',
    addressCity: 'Florianópolis',
    addressProvince: 'SC',
    country: 'Brasil',
    anttNumber: 'TA-654321',
    anttIssueDate: '20/01/2023',
    anttType: { value: 2, label: 'TAC' },
    rntrcOwn: false,
    anttTransporterDocument: '98.765.432/0001-11',
    certificatePath: 'certificados/2026-03/def456.pfx',
    certificatePassword: '••••••••',
    timeline: [
      {
        statusSlug: 'DATA_VALIDATION',
        statusName: 'Em validação',
        createdAt: '2026-03-21T14:00:00',
        completedAt: null,
      },
    ],
    currentStatus: {
      statusSlug: 'DATA_VALIDATION',
      statusName: 'Aguardando validação',
      createdAt: '2026-03-21T14:00:00',
    },
    createdAt: '2026-03-21T14:15:00',
  },
  {
    id: 3,
    userName: 'Carlos Eduardo',
    userDocument: '321.654.987-11',
    userEmail: 'carlos.eduardo@email.com',
    userPhone: '(47) 97777-9012',
    shippingName: 'Carlos Autônomo',
    shippingDocument: '321.654.987-11',
    shippingStateRegistration: '',
    shippingPhone: '(47) 97777-9012',
    shippingEmail: 'carlos.eduardo@email.com',
    autonomous: true,
    shippingType: { value: 3, label: 'CTC' },
    address: 'Rua do Comércio',
    addressNumber: '88',
    addressNeighborhood: 'Vila Nova',
    addressComplement: '',
    addressZipCode: '89200-000',
    addressCity: 'Joinville',
    addressProvince: 'SC',
    country: 'Brasil',
    anttNumber: 'CTC-789123',
    anttIssueDate: '10/04/2021',
    anttType: { value: 3, label: 'CTC' },
    rntrcOwn: true,
    anttTransporterDocument: '',
    certificatePath: '',
    certificatePassword: '',
    timeline: [
      {
        statusSlug: 'DATA_VALIDATION',
        statusName: 'Validação concluída',
        createdAt: '2026-03-22T10:00:00',
        completedAt: '2026-03-22T10:45:00',
      },
      {
        statusSlug: 'EMISSION_PORTAL_REGISTRATION',
        statusName: 'Cadastro concluído',
        createdAt: '2026-03-22T10:50:00',
        completedAt: '2026-03-22T11:30:00',
      },
      {
        statusSlug: 'REGISTRATION_RELEASE',
        statusName: 'Cadastro liberado',
        createdAt: '2026-03-22T11:35:00',
        completedAt: '2026-03-22T12:00:00',
      },
    ],
    currentStatus: {
      statusSlug: 'REGISTRATION_RELEASE',
      statusName: 'Cadastro liberado',
      createdAt: '2026-03-22T11:35:00',
    },
    createdAt: '2026-03-22T10:00:00',
  },
  {
    id: 4,
    userName: 'Ana Paula Souza',
    userDocument: '456.789.123-00',
    userEmail: 'ana.souza@email.com',
    userPhone: '(54) 96666-3456',
    shippingName: 'Carga Segura Transportes ME',
    shippingDocument: '55.444.333/0001-22',
    shippingStateRegistration: '554443330',
    shippingPhone: '(54) 3411-2233',
    shippingEmail: 'contato@cargasegura.com.br',
    autonomous: false,
    shippingType: { value: 1, label: 'ETC' },
    address: 'Rua Marechal Floriano',
    addressNumber: '200',
    addressNeighborhood: 'Centro',
    addressComplement: 'Bloco B',
    addressZipCode: '95000-000',
    addressCity: 'Caxias do Sul',
    addressProvince: 'RS',
    country: 'Brasil',
    anttNumber: 'ET-987654',
    anttIssueDate: '05/03/2020',
    anttType: { value: 1, label: 'ETC' },
    rntrcOwn: true,
    anttTransporterDocument: '',
    certificatePath: 'certificados/2026-03/ghi789.pfx',
    certificatePassword: '••••••••',
    timeline: [],
    currentStatus: null,
    createdAt: '2026-03-23T09:45:00',
  },
  {
    id: 5,
    userName: 'Pedro Henrique Lima',
    userDocument: '654.321.789-00',
    userEmail: 'pedro.lima@email.com',
    userPhone: '(51) 95555-7890',
    shippingName: 'Rotas do Brasil Transporte Ltda',
    shippingDocument: '77.888.999/0001-33',
    shippingStateRegistration: '778889990',
    shippingPhone: '(51) 3100-5566',
    shippingEmail: 'contato@rotasdobrasil.com.br',
    autonomous: false,
    shippingType: { value: 2, label: 'TAC' },
    address: 'Av. Ipiranga',
    addressNumber: '1000',
    addressNeighborhood: 'Partenon',
    addressComplement: '',
    addressZipCode: '90000-000',
    addressCity: 'Porto Alegre',
    addressProvince: 'RS',
    country: 'Brasil',
    anttNumber: 'TA-112233',
    anttIssueDate: '22/08/2024',
    anttType: { value: 2, label: 'TAC' },
    rntrcOwn: false,
    anttTransporterDocument: '77.888.999/0001-33',
    certificatePath: 'certificados/2026-03/jkl012.pfx',
    certificatePassword: '••••••••',
    timeline: [
      {
        statusSlug: 'DATA_VALIDATION',
        statusName: 'Em validação',
        createdAt: '2026-03-24T16:20:00',
        completedAt: null,
      },
    ],
    currentStatus: {
      statusSlug: 'DATA_VALIDATION',
      statusName: 'Em validação',
      createdAt: '2026-03-24T16:20:00',
    },
    createdAt: '2026-03-24T16:20:00',
  },
];

export function findRequestById(id) {
  return mockRequests.find(r => r.id === Number(id)) || null;
}
